/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Contact_Form_Success_BodyInputs */

const en_contact_form_success_body = /** @type {(inputs: Contact_Form_Success_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We will reply to ${i?.email} within one working day.`)
};

const lv_contact_form_success_body = /** @type {(inputs: Contact_Form_Success_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atbildēsim uz ${i?.email} vienas darba dienas laikā.`)
};

/**
* | output |
* | --- |
* | "We will reply to {email} within one working day." |
*
* @param {Contact_Form_Success_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_success_body = /** @type {((inputs: Contact_Form_Success_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Success_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_success_body(inputs)
	return en_contact_form_success_body(inputs)
});